import { useContext } from 'react';

import { SocketContext } from '../SocketProvider';

/**
 * Custom Hook that consumes the socket
 * @returns The socket instance
 */
const useSocket = () => {
	const socket = useContext(SocketContext);
	if (!socket) throw new Error("socket is null, make sure you wrapped your application with 'SocketProvider'");
	return socket;
}

export default useSocket;